import { render, staticRenderFns } from "./Subdivisions.vue?vue&type=template&id=c7136fe0&"
import script from "./Subdivisions.vue?vue&type=script&lang=js&"
export * from "./Subdivisions.vue?vue&type=script&lang=js&"
import style0 from "./Subdivisions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports